module.exports = __webpack_public_path__ + "img/ic24CameraNew.4a509e8c.svg";